define('views/modules/calendar/personal-data/manager/form/personal-data-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textbox',
    'views/parts/form/choices',
    'views/parts/form/select',
    // models
    'models/calendar/personal-data/personal-data-type',
    // services
    'services/user',
    'services/i18n',
    // templates
    'text!templates/modules/calendar/personal-data/manager/form/personal-data-form.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextbox,
    VChoices,
    VSelect,
    // models
    MPersonalDataType,
    // services
    User,
    i18n,
    // templates
    TPersonalDataEditForm
) {

    var VPersonalDataForm = Backbone.View.extend({

        template: TPersonalDataEditForm,

        // abstracting selectors out of the view logic
        regions: {
            root: '#personal-data-edit-form',
            name: ".form-name",
            unit: ".form-unit",
            customUnit: ".form-custom-unit",
            description: ".form-description",
            currentValueType: ".form-current-value-type",
            memberEntry: ".form-member-entry",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.units = new Backbone.Collection([
                { label: MPersonalDataType.prototype.lengthUnits, value: MPersonalDataType.prototype.lengthUnits },
                { label: MPersonalDataType.prototype.weightUnits, value: MPersonalDataType.prototype.weightUnits },
                { label: MPersonalDataType.prototype.distanceUnits, value: MPersonalDataType.prototype.distanceUnits },
                { label: 'other', value: 'other' },
            ]);

            this.unit = new Backbone.Model({ unit: '' });


            this.view = {
                form: {
                    name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: this.model }),
                    unit: new VSelect({ label: 'Unit', attribute: 'unit', title: i18n.t('select-a-unit'), labelposition: 'outer', model: this.unit, collection: this.units }),
                    customUnit: new VTextbox({ label: 'Custom Unit', attribute: 'unit', labelposition: 'outer', model: this.model }),
                    description: new VTextbox({ label: 'Description', attribute: 'description', labelposition: 'outer', model: this.model }),
                    currentValueType: new VChoices({
                        radio: true,
                        groupLabel: 'goal:Set the goal to reach based on',
                        labelposition: "top",
                        attribute: "sumEntry",
                        model: this.model,
                        choices: this.model.getCurrentValueComputeTypes(),
                        onValueChange: this.OnCurrentValueTypeChange,
                        context: this
                    }),
                    memberEntry: new VChoices({ label: "Allow member entry", attribute: "memberEntry", model: this.model }),
                }
            };

            this.listenTo(this.view.form.unit, 'change', this.onUnitChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.name, zone.$name)
                .assign(view.form.unit, zone.$unit)
                .assign(view.form.customUnit, zone.$customUnit)
                .assign(view.form.memberEntry, zone.$memberEntry)
                .assign(view.form.currentValueType, zone.$currentValueType)
                .assign(view.form.description, zone.$description);

            if (this.model.isNew()) {
                this.view.form.unit.setValue('');
            }

            if (! this.model.isNew()) {
                this.view.form.unit.setDisable(true);
                zone.$unit.find('.bootstrap-select').attr('data-toggle', 'tooltip').attr('title', i18n.t('calendar:you-cannot-change-the-unit-for-this-data')).tooltip({ placement: 'top' });

                if (this.model.isConvertible()) {
                    this.view.form.unit.setValue(this.model.get('unit'), { silent: true });
                } else {
                    this.view.form.unit.setValue('other', { silent: true });
                    this.$el.find(this.regions.customUnit).removeClass('hidden');
                }
            }

            return this;
        },

        onUnitChange: function(model, value) {
            this.model.set('unit', '');
            if (value === 'other') {
                this.$el.find(this.regions.customUnit).removeClass('hidden');
            } else {
                this.model.set('unit', value);
                this.$el.find(this.regions.customUnit).addClass('hidden');
            }
        }

    });

    return VPersonalDataForm;

});

